@if (deployToHerokuUrl) {
  <a href="{{deployToHerokuUrl}}" class="deploy-btn" target="_blank">
    <img src="https://www.herokucdn.com/deploy/button.svg" alt="Deploy">
  </a>
}
